import xw from 'xwind';
import styled from '@emotion/styled';

import { Form } from 'formik';

const StyledForm = styled(Form)(xw`w-full flex flex-col items-center`);

export default StyledForm;
